import React, { useEffect, useRef, useState } from 'react';
import { toJS } from 'mobx';
import SportsTeamLogo from '../../../../../../components/teamLogo';

const teamImageState = {
  HOME: '',
  AWAY: ''
};

const HockeyBroadCastItem = ({ selectedPeriod, period, data, teams }) => {
  const [viewDetail, setViewDetail] = useState(false);
  const [teamImages, setTeamImages] = useState(teamImageState);
  const titleComp = useRef();

  const handleToggleDetail = () => {
    const changeView = !viewDetail;
    setViewDetail(!viewDetail);
    if (changeView) {
      const targetScroll = titleComp.current.offsetTop;
      setTimeout(() => {
        window.scrollTo({ top: targetScroll, behavior: 'smooth' });
      }, 10);
    }
  };

  useEffect(() => {
    if (selectedPeriod === parseInt(period)) {
      setViewDetail(true);
    }
  }, []);

  useEffect(() => {
    let teamData = toJS(teams);
    if (teamData !== undefined) {
      setTeamImages({
        HOME: teamData.home.imgPath,
        AWAY: teamData.away.imgPath
      });
    }
  }, [teams]);

  return (
    <dl className={`item ${viewDetail && 'view'}`}>
      <dt ref={titleComp} onClick={handleToggleDetail}>
        <span className={'tit'}>
          {period < 5 ? `${period}피리어드` : `연장`}
        </span>
        <button type="button" className="btn_oc">
          열기/닫기
        </button>
      </dt>
      {data.map((value, key) => {
        const {
          displayTime,
          locationType,
          playerName,
          broadcastType,
          subPlayText,
          playText,
          penaltyTime,
          plusPenaltyTime,
          misconductTime
        } = value;
        const teamImage =
          (locationType !== 'TOTAL' && teamImages[locationType]) || '';
        const isNormalType =
          broadcastType === 'NORMAL' || broadcastType === 'TEXT';
        const isFoul = broadcastType === 'FOUL';
        return (
          <dd key={key}>
            <span className="time">{displayTime}</span>
            <span className={`tx`}>
              {teamImage !== '' && (
                <SportsTeamLogo
                  className="logo"
                  imgUrl={teamImage}
                  isLazy={false}
                  imgSize={20}
                />
              )}

              <span className={'events'}>
                {broadcastType === 'GOAL' && <em className={'goal'} />}
                {broadcastType === 'PENALTY_MISSED' && (
                  <em className={'no_goal'} />
                )}

                {isFoul && (
                  <>
                    {penaltyTime !== null && (
                      <em className={`y${penaltyTime}`} />
                    )}
                    {plusPenaltyTime !== null && (
                      <em className={`y${plusPenaltyTime}`} />
                    )}
                    {misconductTime !== null && <em className={`r10`} />}
                  </>
                )}
                {broadcastType === 'PLAYER_INOUT' && (
                  <em className={'change'} />
                )}
              </span>
              <span className={'texts'}>
                {isNormalType ? (
                  <>
                    {playerName} {playText}
                  </>
                ) : (
                  <>
                    {playerName} {subPlayText}
                  </>
                )}
                <em>{subPlayText}</em>
              </span>
            </span>
          </dd>
        );
      })}
    </dl>
  );
};

export default HockeyBroadCastItem;
